import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import settings from "../../common/settings";

export const getSetting = createAsyncThunk(
	"setting/Settings",
	async (arg, { getState }) => {
		const state = getState();

		try {
			let setting = await settings();

			return setting.data.data;
		} catch (e) {
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Settings: [],
	loading: true,
};

export const SettingSlice = createSlice({
	name: "Setting",
	initialState,
	reducers: {
		setSetting: (state, action) => {
			state.NavLinks = action.payload;
		},
	},
	extraReducers: {
		[getSetting.pending]: (state, action) => {
			state.loading = true;
		},
		[getSetting.fulfilled]: (state, action) => {
			// console.log("action.payload settings ==> ", action.payload);
			state.Settings = action.payload;
			state.loading = false;
		},
		[getSetting.rejected]: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setSetting } = SettingSlice.actions;

export default SettingSlice.reducer;
